import React from "react";
import { Divider, useViewport, Container, Text } from "@bookingcom/bui-react";
import "../TravellerFooter.types";
import InlineLinksList from "./InlineLinksList";
import styles from "../TravellerFooter.module.css";
var MinimalFooter = function (_a) {
    var copyrightText = _a.copyrightText, footerItems = _a.footerItems;
    var isSmall = useViewport().isSmall;
    return (React.createElement("footer", { className: styles["root--variant-minimal"], "data-testid": "minimal-footer" },
        React.createElement(InlineLinksList, { items: footerItems, variant: "dark", linkTextVariant: "body_2" }),
        React.createElement(Container, { centered: true, className: styles["minimal-footer-copyrights-container"] },
            isSmall && (React.createElement(Divider, { className: styles["minimal-footer-copyrights-divider"] })),
            React.createElement(Text, { align: isSmall ? "center" : "left", variant: "small_1" }, copyrightText))));
};
export default MinimalFooter;
